/**
 * Cart Quantity Auto-Update
 * Automatically updates cart when quantity is changed
 * Uses event delegation to prevent multiple listener issues
 */

(function() {
  'use strict';

  // Guard against multiple initializations
  if (window.CartQuantityUpdateInitialized) return;
  window.CartQuantityUpdateInitialized = true;

  let debounceTimer = null;
  let isUpdating = false; // Prevent rapid-fire updates

  function handlePlusClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (isUpdating) return;

    const button = event.target.closest('[data-quantity-plus]');
    if (!button) return;

    const itemKey = button.dataset.itemKey;
    const input = document.querySelector(`input[id*="${itemKey}"]`);

    if (input) {
      const currentQty = parseInt(input.value) || 0;
      input.value = currentQty + 1;
      updateCart(itemKey, currentQty + 1);
    }
  }

  function handleMinusClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (isUpdating) return;

    const button = event.target.closest('[data-quantity-minus]');
    if (!button) return;

    const itemKey = button.dataset.itemKey;
    const input = document.querySelector(`input[id*="${itemKey}"]`);

    if (input) {
      const currentQty = parseInt(input.value) || 0;
      const newQty = Math.max(0, currentQty - 1);
      input.value = newQty;
      updateCart(itemKey, newQty);
    }
  }

  function handleQuantityInput(event) {
    const input = event.target.closest('[data-quantity-input]');
    if (!input) return;

    // Debounce rapid changes
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      handleQuantityChange(input);
    }, 500);
  }

  function handleQuantityChange(input) {
    if (isUpdating) return;

    const newQuantity = parseInt(input.value) || 0;
    const row = input.closest('[data-cart-item-key]');
    if (!row) return;

    const itemKey = row.dataset.cartItemKey;

    if (newQuantity < 0) {
      input.value = 0;
      return;
    }

    updateCart(itemKey, newQuantity);
  }

  function updateCart(itemKey, quantity) {
    if (isUpdating) return;
    isUpdating = true;

    // Save scroll position before reload
    sessionStorage.setItem('cartScrollPosition', window.scrollY);

    // Show loading spinner
    const loadingOverlay = document.getElementById('cartLoadingOverlay');
    if (loadingOverlay) {
      loadingOverlay.classList.add('active');
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      // Reload the page to show updated cart
      window.location.reload();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      isUpdating = false;
      // Hide loading spinner
      if (loadingOverlay) {
        loadingOverlay.classList.remove('active');
      }
      alert('There was an error updating your cart. Please try again.');
    });
  }

  // Use event delegation - attach once to document
  document.addEventListener('click', function(event) {
    if (event.target.closest('[data-quantity-plus]')) {
      handlePlusClick(event);
    } else if (event.target.closest('[data-quantity-minus]')) {
      handleMinusClick(event);
    }
  }, { capture: true });

  // Handle input changes with delegation
  document.addEventListener('change', function(event) {
    if (event.target.closest('[data-quantity-input]')) {
      handleQuantityChange(event.target);
    }
  });

  document.addEventListener('input', function(event) {
    if (event.target.closest('[data-quantity-input]')) {
      handleQuantityInput(event);
    }
  });

  // Restore scroll position after page reload
  window.addEventListener('load', () => {
    const savedPosition = sessionStorage.getItem('cartScrollPosition');
    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition));
      sessionStorage.removeItem('cartScrollPosition');
    }
  });
})();
